module.exports = __webpack_public_path__ + "img/Icon_notifications.1f49d7e4.svg";